import React from 'react'
import Navbar from '../../components/admin/common/Navbar'
import MainEmployeeProfile from "./../../components/admin/employees/employeeProfile/MainEmployeeProfile"

const AgentProfile = () => {
  return (
    <div className="min-h-screen">
    <Navbar />
    <main className="p-4 md:p-8">
     <MainEmployeeProfile/>
    </main>
  </div>
  )
}

export default AgentProfile
